import React from 'react';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import i18n from '@wix/wix-vod-shared/src/common/i18n/index';
import memoizedPartial from 'shared/utils/memoized-partial';
import focus from '@wix/wix-vod-shared/src/widget/utils/accessibility-focus';
import { areElementsRounded, getSiteUrl, getCompId } from 'shared/selectors/app-settings';

import ClosableOverlay from '@wix/wix-vod-shared/src/widget/vod-player/components/closable-overlay/closable-overlay';
import VideoInfo from '../../components/video-info/video-info';
import Animate from '@wix/wix-vod-shared/src/widget/ui-components/animate/animate';

import sharedTranslations from 'messages/shared';
import translations from 'messages/widget';
import INFO_OVERLAY_CONTENT from 'widget/player-widget/components/new-player/containers/animated-overlay-content/info-overlay-content-enums';

import styles from '@wix/wix-vod-shared/src/widget/vod-player/components/actions-panel/actions-panel.scss';


// TBD: should we put it to shared?
@connect((state, ownProps) => ({
  siteUrl: getSiteUrl(state),
  compId: getCompId(state),
  isVideoInfoVisible: ownProps.overlayContent === INFO_OVERLAY_CONTENT.VIDEO_INFO,
  isAllCardsVisible: ownProps.overlayContent === INFO_OVERLAY_CONTENT.ALL_CARDS,
  areElementsRounded: areElementsRounded(state),
}))
export default class AnimatedOverlayContent extends React.Component {

  static propTypes = {
    channelData: PropTypes.object,
    videoItem: PropTypes.object,
    allCardsOverlayContent: PropTypes.node,
    overlayContent: PropTypes.string,
    onClose: PropTypes.func,

    siteUrl: PropTypes.string,
    compId: PropTypes.string,

    isVideoInfoVisible: PropTypes.bool,
    isAllCardsVisible: PropTypes.bool,

    isPlayerInFullScreen: PropTypes.bool,
    areElementsRounded: PropTypes.bool,
  };

  static defaultProps = {
    onClose: _.noop,
  };

  componentDidUpdate(prevProps) {
    const { overlayContent } = this.props;

    if (!overlayContent && prevProps.overlayContent === overlayContent) {
      return;
    }

    const hasChangedToTrue = key => this.props[key] && !prevProps[key];

    if (hasChangedToTrue('isVideoInfoVisible')) {
      focus(this.videoInfoContainerRef);
    }

    if (hasChangedToTrue('isAllCardsVisible')) {
      focus(this.allCardsContainerRef);
    }
  }

  videoInfoContainerRef = null;
  allCardsContainerRef = null;

  @autobind
  saveRef(name, ref) {
    this[name] = ref;
  }

  render() {
    const {
      videoItem: {
        posterUrl,
        title,
        description,
        publisher,
        durationStr,
        genre,
        videoType,
        cast,
        crew,
      },
      allCardsOverlayContent,
      overlayContent,
      isPlayerInFullScreen,
      isVideoInfoVisible,
      isAllCardsVisible,
      onClose,
    } = this.props;

    const classNames = classnames(styles['info-overlay-wrapper'], {
      [styles.active]: overlayContent,
    });
    const infoClassName = styles['info-overlay'];

    return (
      <div className={classNames}>
        <section className={styles['info-overlay-content']}
                 aria-hidden={!isVideoInfoVisible}
                 ref={memoizedPartial(this.saveRef, 'videoInfoContainerRef')}>
          <Animate type="fade-in-out"
                   className={infoClassName}
                   when={isVideoInfoVisible}>
            <ClosableOverlay onClose={onClose}
                             isInFullScreen={isPlayerInFullScreen}
                             posterUrl={posterUrl}
                             closeButtonAriaLabel={i18n.t(translations.closeVideoInfo)}>
              <VideoInfo title={title}
                         description={description}
                         posterUrl={posterUrl}
                         publisher={publisher}
                         genre={genre}
                         videoType={videoType}
                         durationStr={durationStr}
                         durationAriaLabel={i18n.t(translations.duration, { durationStr })}
                         cast={cast}
                         crew={crew}
                         isPlayerInFullScreen={isPlayerInFullScreen} />
            </ClosableOverlay>
          </Animate>
        </section>

        <section className={styles['info-overlay-content']}
                 aria-hidden={!isAllCardsVisible}
                 ref={memoizedPartial(this.saveRef, 'allCardsContainerRef')}>
          <Animate className={infoClassName}
                   when={isAllCardsVisible}>
            <ClosableOverlay onClose={onClose}
                             contentClassName={styles['all-cards-overlay-content']}
                             isFullWidth
                             isFullWidthForced
                             isInFullScreen={isPlayerInFullScreen}
                             closeOnBodyClick
                             closeButtonAriaLabel={i18n.t(sharedTranslations.closeAllCards)}>
              {isAllCardsVisible && allCardsOverlayContent}
            </ClosableOverlay>
          </Animate>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/animated-overlay-content/animated-overlay-content.js